import {
  SET_MEMBER_DATA,
  SET_MEMBERS_DATA,
  SET_MEMBER_COUNT,
  SET_MEMBERS_CHECKIN_DATA,
} from "../../actions/types/types";

const initState = {
  member: {},
  activeMember: {},
  members: [],
  memberInfo: {},
  allMembers: [],
  memberCount: 0,
  giveBackMoneyData: {},
  gymCheckIns: [],
  classCheckIns: [],
  appointmentsCheckIns: [],
  checkinsTotals: undefined,
  freezeAllModalOpen: false,
  freezeMembership: false,
  voidModal: false,
  returnVoidModal: false,
  voidSummary: false,
  voidInfo: undefined,
  formProps: {},
  data: [],
  memberInfoId: "",
  dataLimit: 10,
  dataPage: 1,
  dataCount: 0,
  memberBookingList: [],
  memberBookingListCount: 0,
  memberBookingListLimit: 10,
  memberBookingListPage: 1,
  memberActionPermissions: {},
  memberDocuments: [],
  notes: [],
  activeTab: 1,
  existingMember: {},
  existingMemberModal: false,
  memberGymSubscriptionPage: 1,
  memberGymSubscriptionLimit: 10,
  memberGymSubscriptionList: [],
  memberGymSubscriptionCount: 0,
  memberCheckedInBookings: {},
  memberBookingLoading: false,
  gymSubscriptionLoading: false,
  purchasedProducts: [],
  returnProductModal: false,
  memberPaidJoiningFees: true,
  showVoidedReason: false,
  pushNotificationModalOpen: false,
  memberSharedSubscriptions: [],
  mainSharedSubscription: {},
  showSharedSubscriptionModal: false,
  currentSharedSale: {},
  overLapBookings: [],
  deletedMemberModal: false,
  pushNotificationResults: {
    successCount: 0,
    failedCount: 0,
    openModal: false,
  },
  memberFreezeHistory:{
    _packageInfo:{},
    freezeHistory:[]
  },
  showMemberFreezeHistory:false,
  memberAssessments:[],
  memberTreatments:[]

};

const MemberReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_MEMBER_DATA:
      return {
        ...state,
        member: action.payload.data,
      };
    case "RESET_ACTIVE_MEMBER":
      return {
        ...state,
        member: {},
      };
    case SET_MEMBER_COUNT:
      return {
        ...state,
        memberCount: action.payload.data,
      };
    case "SET_MEMBER_ACTION_PERMISSIONS":
      return {
        ...state,
        memberActionPermissions: {
          ...state.memberActionPermissions,
          ...action.payload.data,
        },
      };
    case "SET_EXISTING_MEMBER":
      return {
        ...state,
        existingMember: action.payload.data,
      };
    case "SET_SHOW_VOIDED_REASON": {
      return {
        ...state,
        showVoidedReason: action.payload.data,
      };
    }

    case "SET_MEMBER_LOADING_LIST":
      return {
        ...state,
        memberBookingLoading: action.payload.data,
      };
    case "SET_MEMBER_LOADING_GYM_SUBSCRIPTION":
      return {
        ...state,
        gymSubscriptionLoading: action.payload.data,
      };

    case "SET_SHOW_EXISTING_MEMBER_MODAL":
      console.log(state.existingMemberModal);
      return {
        ...state,
        existingMemberModal: action.payload.data,
      };
      case "SET_SHOW_DELETED_MEMBER_MODAL":
        return {
          ...state,
          deletedMemberModal: action.payload.data,
        };
      
    case "SET_DATA_LIMIT":
      return {
        ...state,
        dataLimit: action.payload.data,
      };
    case "SET_DATA_PAGE":
      return {
        ...state,
        dataPage: action.payload.data,
      };
    case "SET_DATA_COUNT":
      return {
        ...state,
        dataCount: action.payload.data,
      };
    case "SET_ACTIVE_TAB":
      return {
        ...state,
        activeTab: action.payload.data,
      };
    case "SET_NOTES":
      return {
        ...state,
        notes: action.payload.data,
      };
    case "SET_MEMEBR_PURCHASED_PRODUCTS":
      return {
        ...state,
        purchasedProducts: action.payload.data,
      };

    case "SET_EDIT_FORM_PROPS":
      return {
        ...state,
        formProps: action.payload.data,
      };
    case "SET_DATA":
      return {
        ...state,
        data: action.payload.data,
      };
    case "SET_MEMBER_INFO_ID":
      return {
        ...state,
        memberInfoId: action.payload.data,
      };
    case "SET_ACTIVE_MEMBER":
      return {
        ...state,
        activeMember: action.payload.data,
      };
    // member booking list :
    case "SET_M_BOOKING_LIST":
      return {
        ...state,
        memberBookingList: action.payload.data,
      };
    case "SET_M_BOOKING_LIST_COUNT":
      return {
        ...state,
        memberBookingListCount: action.payload.data,
      };

    case "SET_M_BOOKING_LIST_LIMIT":
      return {
        ...state,
        memberBookingListLimit: action.payload.data,
      };
    case "SET_M_BOOKING_LIST_PAGE":
      return {
        ...state,
        memberBookingListPage: action.payload.data,
      };
    case "SET_M_CHECKED_IN_BOOKINGS":
      return {
        ...state,
        memberCheckedInBookings: action.payload.data,
      };

    case "SET_MEMBER_GYM_SUBSCRIPTIONS_PAGE":
      return {
        ...state,
        memberGymSubscriptionPage: action.payload.data,
      };
    case "SET_MEMBER_GYM_SUBSCRIPTIONS_LIMIT":
      return {
        ...state,
        memberGymSubscriptionLimit: action.payload.data,
      };
    case "SET_MEMBER_GYM_SUBSCRIPTIONS_COUNT":
      return {
        ...state,
        memberGymSubscriptionCount: action.payload.data,
      };
    case "SET_MEMBER_GYM_SUBSCRIPTIONS_LIST":
      return {
        ...state,
        memberGymSubscriptionList: action.payload.data,
      };

    case SET_MEMBERS_DATA:
      return {
        ...state,
        members: action.payload.data,
      };

    case "SET_ALL_MEMBERS_DATA":
      return {
        ...state,
        allMembers: action.payload.data,
      };
    case "GIVE_BACK_MONEY":
      return {
        ...state,
        giveBackMoneyData: action.payload.data,
      };
    case SET_MEMBERS_CHECKIN_DATA:
      return {
        ...state,
        membersCheckin: action.payload.data,
      };
    case "SET_CHECKINS_DATA":
      return {
        ...state,
        gymCheckIns: action.payload.data.data.gymCheckins,
        classCheckIns: action.payload.data.data.classCheckins,
        appointmentsCheckIns: action.payload.data.data.appointmentsCheckin,
        checkinsTotals: action.payload.data.totals,
      };
    case "SET_MEMBER_INFO":
      return {
        ...state,
        memberInfo: action.payload.data,
      };
    case "SET_MEMBER_PAID_JOINING_FEE":
      return {
        ...state,
        memberPaidJoiningFees: action.payload.data,
      };

    case "SET_FREEZE_ALL_MODAL_OPEN":
      return {
        ...state,
        freezeAllModalOpen: action.payload.data,
      };
    case "SET_PUSH_NOTIFCATION_MODAL_OPEN":
      return {
        ...state,
        pushNotificationModalOpen: action.payload.data,
      };
    case "SET_PUSH_NOTIFCATION_MODAL_RESULT":
      return {
        ...state,
        pushNotificationResults: action.payload.data,
      };

    case "SET_FREEZE_MEMBERSHIP_MODAL_OPEN":
      return {
        ...state,
        freezeMembership: action.payload.data,
      };
    case "SET_VOID_MEMBERSHIP_MODAL_OPEN":
      return {
        ...state,
        voidModal: action.payload.data,
      };
    case "SET__RETURN_VOID_MEMBERSHIP_MODAL_OPEN":
      return {
        ...state,
        returnVoidModal: action.payload.data,
      };
    case "SET_RETURN_PRODUCT_OPEN":
      return {
        ...state,
        returnProductModal: action.payload.data,
      };
    case "SET_VOID_SUMMARY_MODAL_OPEN":
      if (action.payload.data === false)
        return {
          ...state,
          voidSummary: action.payload.data,
          voidInfo: undefined,
        };
      return {
        ...state,
        voidSummary: action.payload.data,
      };
    case "SET_VOID_INFO":
      return {
        ...state,
        voidInfo: action.payload.data,
      };
    case "RESET_CHECKINS_DATA":
      return {
        ...state,
        gymCheckIns: undefined,
        classCheckIns: undefined,
        appointmentsCheckIns: undefined,
        checkinsTotals: undefined,
      };
    case "SET_DOCUMENTS_INFO":
      return {
        ...state,
        memberDocuments: action.payload.data,
      };

    case "SET_MEMBER_SHARED_SUBSCRIPTIONS_WITH":
      console.log({payy:action.payload})
      return {
        ...state,
        memberSharedSubscriptions: action.payload.data,
        mainSharedSubscription: action.payload.mainSubsription,
      };
    case "SET_SHOW_MEMBER_SHARED_SUBSCRIPTIONS_MODAL":
      return {
        ...state,
        showSharedSubscriptionModal: action.payload.data,
      };
      case "SET_CURRENT_MEMBER_SHARED_SUBSCRIPTION":
        return {
          ...state,
          currentSharedSale: action.payload.data,
        };
        case "SET_OVERLAP_DATA":
          return {
            ...state,
            overLapBookings: action.payload.data,
          };
        case "SET_MEMBER_FREEZE_HISTORY":
          return {
            ...state,
            memberFreezeHistory: action.payload.data,
          };
        case "SET_MEMBER_FREEZE_HISTORY_SALE_ID":
          return {
            ...state,
            showMemberFreezeHistory: action.payload.data,
          };        
      case "SET_MEMBER_ASSESSMENTS":{
        return {
          ...state,
          memberAssessments:action.payload.data
        }
      }
      case "SET_MEMBER_TREATMENTS":{
        return{
          ...state,
          memberTreatments:action.payload.data
        }
      }
      case "SET_TRANSFERED_TO_MEMBER":{
        return {
          ...state,
          transferedToMember:action.payload.data
        } 
      }
      
    default:
      return { ...state };
  }
};

export default MemberReducer;
